import api from "./api";

export const getOrderItemsByOrderId = (id, page, pageSize) => {
    return api.get(`/order-items/by-order/${id}`, {
        params: {
            page,
            pageSize,
        },
    });
};

export const createOrderItem = (orderItem) => {
    // Always use FormData to match backend expectation
    const formData = new FormData();
    // Remove the file from orderItem and convert to JSON
    const { file, ...orderItemData } = orderItem;

    // Create a proper Blob for web browsers (equivalent to mobile's jsonBlob)
    const jsonBlob = new Blob([JSON.stringify(orderItemData)], {
        type: 'application/json'
    });

    formData.append('orderItem', jsonBlob, 'orderItem.json');

    // Add file if present
    if (file) {
        formData.append('file', file);
    }

    return api.post('/order-items', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const updateOrderItem = (id, orderItem) => {
    // Always use FormData to match backend expectation
    const formData = new FormData();
    // Remove the file from orderItem and convert to JSON
    const { file, ...orderItemData } = orderItem;

    // Create a proper Blob for web browsers (equivalent to mobile's jsonBlob)
    const jsonBlob = new Blob([JSON.stringify(orderItemData)], {
        type: 'application/json'
    });

    formData.append('orderItem', jsonBlob, 'orderItem.json');

    // Add file if present
    if (file) {
        formData.append('file', file);
    }

    return api.put(`/order-items/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const downloadOrderItemFile = async (itemId) => {
    const response = await api.get(`/order-items/${itemId}/file`, {
        responseType: 'blob'
    });
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'document.pdf';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const deleteOrderItem = (id) => {
    return api.delete(`/order-items/${id}`);
};

export const getOrderItemsByEmployeeId = (employeeId) => {
    return api.get(`/order-items/by-employee/${employeeId}`);
};

export const getAssignedOrderItemsByEmployeeId = (employeeId) => {
    return api.get(`/order-items/by-assigned-employee/${employeeId}`);
};

export const updateOrderItemStatus = (id, status) => {
    return api.put(`/order-items/status/${id}`, { "status": status });
};

export const updateOrderItemNote = (orderItemId, employeeId, notes) => {
    return api.put(`/order-items/update-note/${orderItemId}/${employeeId}`, { notes });
};

export const downloadOrderPdf = async (orderId) => {
    try {
        const response = await api.get(`/pdf/order/${orderId}`, {
            responseType: "blob"
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `siparis_${orderId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Failed to download PDF:", error);
        throw error;
    }
};

export const uploadOrderItemsExcel = (orderId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const userId = localStorage.getItem('userId');
    return api.post(`/excel/order/${orderId}/upload`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "X-User-Id": userId || ''
        },
    });
};